import AnnotationSequence from './AnnotationSequence';

export default AnnotationSequence;
